import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function UsersIcon(t0) {
  const $ = _c(8);
  let svg;
  if ($[0] !== t0) {
    ({
      ...svg
    } = t0);
    $[0] = t0;
    $[1] = svg;
  } else {
    svg = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />;
    t2 = <circle cx="9" cy="7" r="4" />;
    t3 = <path d="M22 21v-2a4 4 0 0 0-3-3.87" />;
    t4 = <path d="M16 3.13a4 4 0 0 1 0 7.75" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== svg) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" role="img" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...svg}>{t1}{t2}{t3}{t4}</svg>;
    $[6] = svg;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
UsersIcon.displayName = "UsersIcon";